/*
  Aviso "Elige tus perfumes" en los productos que exigen selección (2026-08-17).

  El problema: en productos con la app Infinite Options (Arma tu Discovery Box), si
  el cliente toca "Agregar al carrito" sin elegir sus perfumes, la app anula el clic
  y no ocurre absolutamente nada. Ni mensaje, ni movimiento. El cliente cree que la
  tienda está rota.

  Cómo se detecta el producto: por el bloque de la app. En un producto con selección
  mide más de 2000px de alto; en uno normal se renderiza con alto 0. Por eso este
  script no hace nada en las fichas corrientes.

  Cómo se detecta el bloqueo: la app intercepta el clic tan arriba que no llega al
  botón ni dispara el submit del formulario, así que no hay evento al que engancharse.
  Lo que sí funciona es escuchar el clic en el documento en fase de captura y después
  comparar el carrito: si no cambió, la compra no entró.

  La app además avisa con una ventana del navegador en inglés ("Please select your
  options..."). Se sustituye por el aviso en español del tema: se intercepta
  window.alert y, si el mensaje es el suyo, se muestra el aviso propio en vez de la
  ventana. De paso el aviso deja de tener retraso, porque la app avisa al instante.

  El mensaje reutiliza el cuadro de error que ya trae el tema, para que se vea igual
  que el resto de avisos de Shopify.
*/
(function () {
  var TEXTO = 'Elige tus perfumes';
  var ESPERA = 1200; // ms que se le dan a la app para procesar el clic

  function bloqueDeSeleccion() {
    var app = document.querySelector('.product__info-container .shopify-app-block');
    // offsetHeight 0 = la app no renderizó opciones para este producto.
    return app && app.offsetHeight > 0 ? app : null;
  }

  function cajaDeError() {
    return document.querySelector('.product-form__error-message-wrapper');
  }

  function mostrarAviso(app) {
    var caja = cajaDeError();
    if (caja) {
      var texto = caja.querySelector('.product-form__error-message');
      if (texto) texto.textContent = TEXTO;
      caja.removeAttribute('hidden');
    }
    // Lleva al cliente hasta el selector: el aviso solo no basta si está lejos.
    app.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function ocultarAviso() {
    var caja = cajaDeError();
    if (caja) caja.setAttribute('hidden', '');
  }

  function unidadesEnCarrito() {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { return c.item_count; })
      .catch(function () { return null; });
  }

  document.addEventListener(
    'click',
    function (evento) {
      var destino = evento.target.closest
        ? evento.target.closest('.product-form__submit')
        : null;
      if (!destino) return;

      var app = bloqueDeSeleccion();
      if (!app) return; // producto sin selección: no se hace nada

      unidadesEnCarrito().then(function (antes) {
        if (antes === null) return;
        setTimeout(function () {
          unidadesEnCarrito().then(function (despues) {
            // Si el carrito no cambió, la app bloqueó la compra.
            if (despues !== null && despues === antes) mostrarAviso(app);
          });
        }, ESPERA);
      });
    },
    true // captura: la app anula el clic antes de que llegue al botón
  );

  // Sustituye la ventana en inglés de la app por el aviso en español del tema.
  var alertaOriginal = window.alert;
  window.alert = function (mensaje) {
    var app = bloqueDeSeleccion();
    if (app && /select your options/i.test(String(mensaje || ''))) {
      mostrarAviso(app);
      return;
    }
    return alertaOriginal.apply(window, arguments);
  };

  // En cuanto el cliente toca el selector, el aviso deja de tener sentido.
  document.addEventListener('change', function (evento) {
    if (evento.target.closest && evento.target.closest('.shopify-app-block')) ocultarAviso();
  });
})();
